import { useAtom } from 'jotai';
import { ConfiguredCarCatalogImage, RenderedCarImageFragment } from '~/graphql/__generated__/graphql';
import { imagesAtom } from '~/graphql/hooks/configurator-context';
import { createRecord } from '~/utils/create-record';

export type ExtendedCatalogImage = ConfiguredCarCatalogImage & { altTextMetaKeys?: string[]; itemName?: string };

export function useImages() {
	const [allImages] = useAtom(imagesAtom);

	const mediaByProfileIdEnv1 = createRecord(
		allImages,
		(image) => matchImageId(image.profileId),
		(image) => convertRenderedFragmentToMediaItemEnv1(image, allImages),
	);

	const imagesByProfileId = createRecord(
		allImages,
		(image) => matchImageId(image.profileId),
		(image) => image.url,
	);

	const mediaByProfileId = createRecord(
		allImages,
		(image) => matchImageId(image.profileId),
		(image) => convertRenderedFragmentToMediaItem(image),
	);

	return {
		mediaByProfileIdEnv1,
		imagesByProfileId,
		mediaByProfileId,
	};
}

const matchImageId = (imageId: string) => (imageId.includes('env1') ? imageId.replace(/env1xl$/, 'xl') : imageId);
const matchImageIdWithEnv1 = (imageId: string) =>
	!imageId.includes('env1') ? imageId.replace(/xl$/, 'env1xl') : imageId;

const convertRenderedFragmentToMediaItemEnv1 = (
	fragment: RenderedCarImageFragment,
	allImages: RenderedCarImageFragment[],
): ExtendedCatalogImage => {
	const env1Url =
		allImages.find((image) => matchImageIdWithEnv1(image.profileId) === matchImageIdWithEnv1(fragment.profileId))
			?.url ?? fragment.url;

	return {
		__typename: 'ConfiguredCarCatalogImage',
		url: env1Url,
		mimeType: fragment.mimeType,
		width: fragment.width,
		altTextMetaKeys: fragment.altTextMetaKeys,
	};
};

const convertRenderedFragmentToMediaItem = (fragment: RenderedCarImageFragment): ExtendedCatalogImage => {
	return {
		__typename: 'ConfiguredCarCatalogImage',
		url: fragment.url,
		mimeType: fragment.mimeType,
		width: fragment.width,
		altTextMetaKeys: fragment.altTextMetaKeys,
	};
};
